import { render, staticRenderFns } from "./WhosesaleContractInfo.vue?vue&type=template&id=10add092&"
import script from "./WhosesaleContractInfo.vue?vue&type=script&lang=js&"
export * from "./WhosesaleContractInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports